import { makeStyles } from "@material-ui/styles";

const appLoadingProgressStyles = makeStyles(() => ({
	container: {
		minHeight: "100vh",
		"& h3": {
			marginTop: 30
		}
	},
	circularProgress: {
		color: "#3C537D"
	}
}));

export default appLoadingProgressStyles;
